import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import Contact from './Containers/Contact';
import Menu from './Containers/Menu';
import Pages from './Containers/Pages';
import Career from './Containers/Career';
import Home from './Containers/Home';
import Gallery from './Containers/Gallery';
import ShishaTerrace from './Containers/ShishaTerrace';
import Kalagram from './Containers/Kalagram';
import ParkingVideo from './Containers/ParkingVideo';
import Blogs from './Containers/Blogs';
import News from './Containers/News';
import BlogDetailPage from './Containers/BlogDetailPage';
import GalleryDetailPage from './Containers/GalleryDetailPage';
import NewsPage from './Containers/NewsPage';
import MenuDetail from './Containers/MenuDetail';
import Weddings from './Containers/Weddings';
import ThankYouPage from './Containers/ThankyouPage';
import NotFound from './Containers/NotFound';
import WeddingVenue from './Containers/WeddingVenue';
import Officialpage from './Containers/Officialpage';
import Homepage2 from './Containers/Homepage2';
import AboutUs from './Containers/AboutUs';
import Terrace from './Containers/Terrace';
import EventsPrivateDining from './Containers/EventsPrivateDining';
import Faqs from './Containers/Faqs';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route exact path='/' activeClassName="active" element={<Homepage2 />} />
          <Route exact path='/contact' activeClassName="active" element={<Contact />} />
          <Route exact path='/about-us' activeClassName="active" element={<AboutUs />} />
          <Route exact path='/menu' activeClassName="active" element={<Menu />} />
          <Route exact path='/menu/:slug' activeClassName="active" element={<MenuDetail />} />

          <Route exact path='/career' activeClassName="active" element={<Career />} />
          <Route exact path='/terraceold' activeClassName="active" element={<ShishaTerrace />} />
          <Route exact path='/terrace' activeClassName="active" element={<Terrace />} />
          <Route exact path='/kalagram' activeClassName="active" element={<Kalagram />} />
          <Route exact path='/events-and-private-dining' activeClassName="active" element={<EventsPrivateDining />} />
          <Route exact path='/faqs' activeClassName="active" element={<Faqs />} />

          <Route exact path='/parking-video' activeClassName="active" element={<ParkingVideo />} />
          <Route exact path='/gallery' activeClassName="active" element={<Gallery />} />
          <Route exact path='/blogs' activeClassName="active" element={<Blogs />} />
          <Route exact path='/blogs/category/:slug' activeClassName="active" element={<Blogs />} />
          <Route exact path='/blogs/:slug' activeClassName="active" element={<BlogDetailPage />} />
          <Route exact path='/gallery/:slug' activeClassName="active" element={<GalleryDetailPage />} />
          <Route exact path='/news' activeClassName="active" element={<News />} />
          <Route exact path='/newsdetails' activeClassName="active" element={<NewsPage />} />
          <Route exact path='/wedding-venue-in-london' activeClassName="active" element={<Weddings />} />
          <Route exact path='/best-indian-restaurant-in-london' activeClassName="active" element={<WeddingVenue />} />
          <Route exact path='/cd-london-official' activeClassName="active" element={<Officialpage />} />
          <Route exact path='/best-royal-restaurant-in-london' activeClassName="active" element={<Home />} />
          <Route path="/*" element={<Navigate to="/404" replace />} />
          <Route path="/404" element={<NotFound />} />


          {/* <Route exact path='/thank-you' activeClassName="active" element={ <ThankYouPage /> }/> */}





          <Route exact path='/:slug' activeClassName="active" element={<Pages />} />




        </Routes>
      </Router>
    </div>
  );
}

export default App;
